import React from "react";
import { IAnswer } from "../../constants/types";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { QuestionAnswerLables } from "./QuestionAnswerLables";
import { QuestionIcons } from "./QuestionIcons";

interface IProps {
  title: string;
  isAnswerLabels?: boolean;
  question: React.ReactNode;
  respond: React.ReactNode;
  height: number;
  answers: Record<string, IAnswer> | IAnswer[];
}

export const QuestionLayout: React.FC<IProps> = (props) => (
  <Grid container spacing={2} my={1}>
    <Grid item>
      <QuestionIcons height={props.height} />
    </Grid>
    <Grid item xs>
      <Grid container direction="column">
        <Grid item xs mb={2}>
          <Typography fontWeight={600}>{props.title}</Typography>
        </Grid>
        {props.isAnswerLabels && (
          <Grid item xs>
            <QuestionAnswerLables answers={props.answers} />
          </Grid>
        )}
        <Grid item xs mb={3}>
          {props.question}
        </Grid>
        <Grid item xs mb={2}>
          <Typography fontWeight={600}>How should your roommate respond?</Typography>
        </Grid>
        {props.isAnswerLabels && (
          <Grid item xs>
            <QuestionAnswerLables answers={props.answers} />
          </Grid>
        )}
        <Grid item xs mb={3} mt={1}>
          {props.respond}
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

QuestionLayout.defaultProps = {
  isAnswerLabels: false,
};
